module.exports = __webpack_public_path__ + "static/vrock-476b629851c8ecdd533ac759521224bc.jpg";